// @flow
import path from 'ramda/es/path';

import shopApiRequest from 'app/actions/shopApi';
import action from 'app/common/lib/action';
import { toCamelCase } from 'app/common/lib/object';


export const SHOP_ADD2CART_REQUEST = 'SHOP_ADD2CART_REQUEST';
export const SHOP_ADD2CART_SUCCESS = 'SHOP_ADD2CART_SUCCESS';
export const SHOP_ADD2CART_FAILURE = 'SHOP_ADD2CART_FAILURE';


/**
 * Добавление данных в корзину
 */
export const add2cart = (itemId: number, quantity: number) => async (dispatch: Function, getState: Function) => {
  const inData = { variant_id: itemId, quantity };
  const { id } = getState().shop.cart;
  dispatch(action(SHOP_ADD2CART_REQUEST, { cartId: id, itemId, ...inData }));
  try {
    const res = await shopApiRequest(`carts/${id}/cart_items`, 'post', { data: inData });
    const data = toCamelCase(path(['data', 'data'], res));
    dispatch(action(SHOP_ADD2CART_SUCCESS, data));
    return true;
  } catch (error) {
    dispatch(action(SHOP_ADD2CART_FAILURE, {
      err: 'Добавление в корзину не удалось',
      data: { cartId: id, itemId, ...inData },
      error,
    }));
    return false;
  }
};
